import { capitalize, chain } from "lodash"

const NAME_PATTERN = /^[A-Za-z0-9_\-\s]{3,50}$/

export const validateTopicName = name => {
  return name.match(NAME_PATTERN)
}

export const computeSecurityInfo = security => {
  return chain(security)
    .pick(["ticker", "mic", "exchange", "country", "internalId"])
    .thru(info => ({
      ...info,
      mic: info.mic || info.exchange,
    }))
    .omitBy((item, key) => !item || key === "exchange")
    .value()
}

export const computeSecurityInstrumentName = security => {
  const info = computeSecurityInfo(security)
  const name = chain(info)
    .map((value, key) => key !== "internalId" && `${capitalize(key)}: ${value}`)
    .compact()
    .value()
  return name.length > 0 ? name.join(", ") : "Unknown instrument"
}
